export default "__VITE_ASSET__D5EEW99W__"